import React, { Component } from 'react';

// import ProjectsGraphQlController from '../../../../controllers/projectsGraphQl';
// import { gql } from '@apollo/client';
// import ShootsListTableRow from '../../../components/shootListTableRow';
import _, { forEach } from 'lodash';
// import LoadingBar from '../../../components/global/loadingBar';
import Modal from '../../components/modals';
// import LoadingBar from '../../../components/global/loadingBar'
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import Select, { components } from 'react-select';
// import ProjectTable from '../../../components/projectTable';
// import { ReactComponent as Down } from /svg/down-arrow-search.svg'
// import { ReactComponent as Down } from '../../../../assets/svg/down-arrow-search.svg';
// import { ReactComponent as Open } from '../../../../assets/svg/open.svg';
import { withRouter } from '../../../services/withRoute';
import { ReactComponent as MoreIconNew } from '../../../assets/svg/more-icon.svg';
import { ReactComponent as FullScreen } from '../../../assets/svg/small-screen.svg';
import { ReactComponent as Info } from '../../../assets/svg/info-icon.svg';
import { ReactComponent as CrossIcon } from '../../../assets/svg/cross.svg';
import { ReactComponent as CrossIcon3 } from '../../../assets/svg/cross3.svg';
import { ReactComponent as CrossIcon2 } from '../../../assets/svg/white-cross.svg';
import { ReactComponent as TickIcon } from '../../../assets/svg/expense-tick.svg';
// import moment from 'moment';
class EqTableFullScreen extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showMemoryCardDropdown: false,
			showMemoryCardAssignModal: false,
			showMemoryCardReceiveModal: false,
			showEquimentDropdown: false,
			showEquimentAssignModal: false,
			showEquimentReceiveModal: false,
			eqCurrFilter: '',
			eventDetails: props.eventDetails,
		};
		this.equipmentRef = React.createRef();
		this.equipmentDropdownRef = React.createRef();
	}
	componentDidMount = () => {
		this.setState({
			eqCurrFilter: this.props.eqCurrFilter,
		});

		let unregisteredEqs = [];
		let equipmentsList = [];
		let eventDetails = _.cloneDeep(this.props.eventDetails);
		_.map(this.props.eventDetails.unregisteredEqs, (equipment) => {
			let receivedQuantity = equipment.receivedQuantity ? equipment.receivedQuantity : 0;
			for (let index = 0; index < equipment.quantity; index++) {
				if (receivedQuantity > 0) {
					unregisteredEqs.push({ ...equipment, isReceived: true, status: 'ready' });
					receivedQuantity = receivedQuantity - 1;
				} else unregisteredEqs.push(equipment);
			}
		});

		equipmentsList = _.concat(
			this.props.eventDetails.equipments ? this.props.eventDetails.equipments : [],
			unregisteredEqs,
		);

		eventDetails.equipments = equipmentsList;
		this.setState({ eventDetails });

		document.addEventListener('mousedown', this.handleClickOutside);
	};
	componentWillReceiveProps = (nextProps) => {
		if (nextProps.eqCurrFilter !== this.state.eqCurrFilter) {
			this.setState({
				eqCurrFilter: nextProps.eqCurrFilter,
			});
		}
	};
	componentWillUnmount = () => {
		document.removeEventListener('mousedown', this.handleClickOutside);
	};
	toggleEquipmentDropDown = (e) => {
		this.setState({
			showEquimentDropdown: !this.state.showEquimentDropdown,
		});
	};
	showEquimentAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-equipment`,
		);
	};
	showEquimentReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-equipment`,
		);
	};
	toggleMemoryCardDropDown = (e) => {
		this.setState({
			showMemoryCardDropdown: !this.state.showMemoryCardDropdown,
		});
	};
	showMemoryCardAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardAssignModal: !this.state.showMemoryCardAssignModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardAssignModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showMemoryCardReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardReceiveModal: !this.state.showMemoryCardReceiveModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardReceiveModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showRecordABackUpModal = (e) => {
		this.setState({
			showRecordABackUpModal: !this.state.showRecordABackUpModal,
		});
	};
	showReAssignMemoryCards = (e) => {
		this.setState({
			showReAssignMemoryCards: !this.state.showReAssignMemoryCards,
		});
	};

	showReAssignEquipments = (e) => {
		this.setState({
			showReAssignEquipments: !this.state.showReAssignEquipments,
		});
	};
	handleClickOutside = (event) => {
		if (
			this.equipmentRef.current &&
			!this.equipmentRef.current.contains(event.target) &&
			this.equipmentDropdownRef.current &&
			!this.equipmentDropdownRef.current.contains(event.target)
		) {
			this.setState({
				showEquimentDropdown: false,
			});
		}
	};
	handleCloseModal = () => {
		this.props.handleClose();
	};
	getAllAssignedToNames2 = () => {
		let arr = [];
		let newArr = [];
		if (this.state.eventDetails.equipments) {
			for (let i = 0; i < this.state.eventDetails.equipments.length; i++) {
				if (!arr.includes(this.state.eventDetails.equipments[i].userName)) {
					arr.push(this.state.eventDetails.equipments[i].userName);
				}
			}
			for (let i = 0; i < arr.length; i++) {
				let tc = 0;
				let rc = 0;
				for (let j = 0; j < this.state.eventDetails.equipments.length; j++) {
					if (this.state.eventDetails.equipments[j].userName === arr[i]) {
						tc += 1;
						if (this.state.eventDetails.equipments[j].isReceived === true) {
							rc += 1;
						}
					}
				}
				newArr.push({ name: arr[i], tc: tc, rc: rc });
			}
		}

		return newArr;
	};
	getReceivedCount2 = () => {
		let c = 0;
		if (this.state.eventDetails.equipments && this.state.eventDetails.equipments.length !== 0) {
			let arr = this.state.eventDetails.equipments.filter((el) => el.isReceived === true);
			c = arr.length;
		}
		return c;
	};
	getNotReceivedCount2 = () => {
		let c = 0;
		if (this.state.eventDetails.equipments) {
			for (let i = 0; i < this.state.eventDetails.equipments.length; i++) {
				if (this.state.eventDetails.equipments[i].isReceived === false) {
					c += 1;
				}
			}
		}

		return c;
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
				// isOverflowVisible={true}
			>
				<div className="busy-modal" style={{ width: '100vw', height: '100vh' }}>
					<div className="bm-header3">
						<div
							style={{
								// padding: '20px 0',
								display: 'flex',
								flexDirection: 'column',
								width: '100%',
								gap: '10px',
							}}
						>
							<div
								style={{
									width: '100%',
									padding: '12px',
									display: 'flex',
									color: 'white',
									alignItems: 'center',
									gap: '70vw',
									justifyContent: 'space-between',
									// gap: '40vw',
								}}
							>
								<p style={{ fontSize: '18px' }}>
									EQUIPMENTS(
									{this.state.eventDetails.equipments
										? this.state.eventDetails.equipments.length
										: '0'}
									)
								</p>
								<div
									style={{
										disply: 'flex',
										alignItems: 'center',
										gap: '10px',
									}}
								>
									<FullScreen
										style={{
											height: '20px',
											width: '20px',
											marginRight: '15px',
											cursor: 'pointer',
										}}
										onClick={() => {
											this.props.handleClose();
										}}
									/>
									<span
										onClick={(e) => this.toggleEquipmentDropDown(e)}
										ref={this.equipmentRef}
									>
										<MoreIconNew
											style={{
												height: '20px',
												width: '20px',
												cursor: 'pointer',
											}}
										/>
									</span>
								</div>
							</div>
							<div
								className="shoot-page-sub-header-container2"
								style={{
									display: 'flex',
									alignItems: 'center',
									gap: '10px',
									fontSize: '14px',
									flexWrap: 'wrap',
								}}
							>
								<div
									//
									className={
										'sub-filter-item' +
										(this.state.eqCurrFilter === 'All' ? ' active' : '')
									}
									onClick={() => {
										if (this.state.eqCurrFilter !== 'All') {
											this.props.eqOnChangeFIlter('All');
										}
									}}
								>
									All{' '}
									{this.state.eventDetails.equipments
										? this.state.eventDetails.equipments.length
										: '0'}
								</div>
								{this.getReceivedCount2() > 0 ? (
									<div
										className={
											'sub-filter-item' +
											(this.state.eqCurrFilter === 'notReceived'
												? ' active'
												: '')
										}
										style={{
											// padding: '8px 12px ',
											// borderRadius: '30px',
											// backgroundColor: '#1C1C1C',
											color: '#CA5A4F',
										}}
										onClick={() => {
											if (this.state.eqCurrFilter !== 'notReceived') {
												this.props.eqOnChangeFIlter('notReceived');
											}
										}}
									>
										Not Received {this.getNotReceivedCount2()}
									</div>
								) : (
									<></>
								)}
								{/* <p
									style={{
										padding: '8px 12px ',
										borderRadius: '30px',
										backgroundColor: '#1C1C1C',
										color: '#CA5A4F',
									}}
								>
									Not Received {this.getNotReceivedCount()}
								</p> */}
								{/* {this.getAllAssignedToNames2().map((el) => {
									return (
										<>
											<p
												style={{
													padding: '8px 12px ',
													borderRadius: '30px',
													backgroundColor: '#1C1C1C',
													color: '#B0B0B0',
												}}
											>
												{el.name} {el.rc}/{el.tc}
											</p>
										</>
									);
								})} */}
								{_.map(
									_.groupBy(
										_.sortBy(this.state.eventDetails.equipments, [
											'isReceived',
										]),
										'userId',
									),
									(item, userId) => {
										return (
											<div
												className={
													'sub-filter-item' +
													(this.state.eqCurrFilter === userId
														? ' active'
														: '')
												}
												// style={{
												// 	padding: '8px 12px ',
												// 	borderRadius: '30px',
												// 	backgroundColor: '#1C1C1C',
												// 	color: '#B0B0B0',
												// 	cursor: 'pointer',
												// }}
												// className={
												// 	'sub-filter-item' +
												// 	(this.state.eqCurrFilter ===
												// 	userId
												// 		? ' active'
												// 		: '')
												// }
												onClick={() => {
													if (this.state.eqCurrFilter !== userId) {
														this.props.eqOnChangeFIlter(userId);
													}
												}}
											>
												<span className="title">
													{_.size(
														_.filter(this.props.tenantUsersList, {
															id: userId,
														}),
													) > 0
														? _.filter(this.props.tenantUsersList, {
																id: userId,
														  })[0].firstName +
														  ' ' +
														  _.filter(this.props.tenantUsersList, {
																id: userId,
														  })[0].lastName
														: ''}
												</span>
												<span className="title">
													{' ' +
														_.size(
															_.filter(
																this.state.eventDetails.equipments,
																{
																	userId: userId,
																	isReceived: true,
																},
															),
														)}
													/{_.size(item)}
												</span>
											</div>
										);
									},
								)}
								{/* <p
									style={{
										padding: '8px 12px ',
										borderRadius: '30px',
										backgroundColor: '#1C1C1C',
										color: '#B0B0B0',
									}}
								>
									Abhishek Chauhan 0/4
								</p>
								<p
									style={{
										padding: '8px 12px ',
										borderRadius: '30px',
										backgroundColor: '#1C1C1C',
										color: '#B0B0B0',
									}}
								>
									Sandeep Kollabathula 12/16
								</p> */}
							</div>
							{this.state.eventDetails.equipments ? (
								<div
									className="shoot-page-sub-header-container2"
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '10px',
										fontSize: '14px',
										flexWrap: 'wrap',
									}}
								>
									{_.map(
										_.groupBy(
											this.state.eventDetails.equipments.filter((item12) =>
												item12.hasOwnProperty('eqId'),
											),
											(item) =>
												item.branch ? item.branch.branchId : 'No Branch',
										),

										(item, userId) => {
											return (
												<div className={'sub-filter-item'}>
													<span className="title">{userId}</span>
													<span className="title">
														{' ' +
															_.size(
																_.filter(
																	this.state.eventDetails
																		.equipments,
																	{
																		branch:
																			userId === 'No Branch'
																				? null
																				: {
																						branchId:
																							userId,
																				  },
																		isReceived: true,
																	},
																),
															)}
														/{_.size(item)}
													</span>
												</div>
											);
										},
									)}
								</div>
							) : (
								''
							)}
						</div>
					</div>
					<div
						style={{
							maxHeight: 'calc(100vh - 220px)',
							overflowY: 'scroll',
							width: '100%',
						}}
					>
						<table
							className="memoryCardSumaryTable2"
							style={{
								borderLeft: '0.5px solid  #383838',
								borderTop: '0.5px solid  #383838',
								color: 'white',
								width: '100%',
								// width: '48vw',
							}}
						>
							<thead
								style={{
									position: 'sticky',
									top: '0px',
								}}
							>
								<tr>
									<th style={{ color: '#B0B0B0' }}>S.NO</th>
									<th style={{ color: '#B0B0B0', minWidth: '300px' }}>
										DESCRIPTION
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '180px' }}>
										SERIAL NO.
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '180px' }}>
										BRANCH ID
									</th>
									<th style={{ color: '#B0B0B0' }}>QR CODE</th>
									<th style={{ color: '#B0B0B0', minWidth: '180px' }}>
										ASSIGNED TO
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '200px' }}>
										ASSIGNED AT
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '200px' }}>
										ASSIGNED BY
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '180px' }}>
										RECEIVED
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '180px' }}>
										RECEIVED BY
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '180px' }}>
										RECEIVED FROM
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '200px' }}>
										RECEIVED AT
									</th>
									<th style={{ color: '#B0B0B0', minWidth: '150px' }}>STATUS</th>
								</tr>
							</thead>
							<tbody>
								{this.state.eventDetails.equipments &&
									_.map(
										this.state.eqCurrFilter === 'All'
											? _.orderBy(
													this.state.eventDetails.equipments,
													'isReceived',
											  )
											: this.state.eqCurrFilter === 'notReceived'
											? _.filter(
													_.sortBy(this.state.eventDetails.equipments, [
														'isReceived',
														'status',
														'isEmpty',
													]),
													{
														isReceived: false,
													},
											  )
											: _.filter(
													_.orderBy(
														this.state.eventDetails.equipments,
														'isReceived',
													),
													{
														userId: this.state.eqCurrFilter,
													},
											  ),
										(el, idx) => {
											return (
												<tr>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{idx + 1}
													</td>
													<td
														style={{
															// textAlign: 'center',
															paddingLeft: '10px',

															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.description}
													</td>
													<td
														style={{
															// textAlign: 'center',
															paddingLeft: '10px',

															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.manufacturerId}
													</td>
													<td
														style={{
															// textAlign: 'center',
															paddingLeft: '10px',

															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.branch?.branchId || ''}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.qrCode}
													</td>

													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.userName}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.createdAt ? (
															<p>
																{moment
																	.unix(el.createdAt)
																	.format('DD/MM/YY,hh:mm a')}
															</p>
														) : (
															<p></p>
														)}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.createdBy && _.has(el.createdBy, 'name')
															? el.createdBy.name
															: ''}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.isReceived ? (
															<TickIcon />
														) : _.size(
																_.filter(
																	this.state.eventDetails
																		.equipments,
																	{
																		isReceived: true,
																	},
																),
														  ) > 0 ? (
															<CrossIcon2
																style={
																	{
																		// height: '35px',
																		// width: '35px',
																	}
																}
															/>
														) : (
															<CrossIcon
																style={{
																	height: '35px',
																	width: '35px',
																}}
															/>
														)}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{!_.has(el, 'qrCode') &&
														el.isReceived === false ? (
															<p></p>
														) : el.receivedBy ? (
															<p>{el.receivedBy.name}</p>
														) : (
															<p></p>
														)}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{!_.has(el, 'qrCode') &&
														el.isReceived === true ? (
															<p>{el.userName}</p>
														) : el.receivedFrom ? (
															<p>{el.receivedFrom.name}</p>
														) : (
															<p></p>
														)}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{!_.has(el, 'qrCode') &&
														el.isReceived === false ? (
															<p></p>
														) : el.receivedAt ? (
															<p>
																{moment
																	.unix(el.receivedAt)
																	.format('DD/MM/YY,hh:mm a')}
															</p>
														) : (
															<p></p>
														)}
													</td>
													<td
														style={{
															textAlign: 'center',
															backgroundColor:
																!el.isReceived &&
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.equipments,
																		{
																			isReceived: true,
																		},
																	),
																) > 0
																	? '#7A2915'
																	: '#121212',
														}}
													>
														{el.status === 'ready'
															? 'Received'
															: 'Not Received'}
													</td>
												</tr>
											);
										},
									)}
							</tbody>
						</table>
						{this.state.showEquimentDropdown ? (
							<div
								className=""
								style={{
									display: 'flex',
									flexDirection: 'column',
									// alignItems: 'center',
									padding: '15px',
									backgroundColor: 'white',
									color: 'black',
									borderRadius: '8px',
									width: '259px',
									// width: 'auto',
									fontWeight: '500',
									gap: '15px',
									position: 'absolute',
									zIndex: '99999999999999',
									marginBottom: '60%',
									marginLeft: '38vw',
									top: '30px',
									right: '30px',
								}}
								ref={this.equipmentDropdownRef}
							>
								<a
									style={{
										cursor: 'pointer',
									}}
									onClick={(e) => this.showEquimentAssignModal(e)}
								>
									Assign Equipments
								</a>
								<a
									style={{
										cursor: 'pointer',
									}}
									onClick={(e) => this.showEquimentReceiveModal(e)}
								>
									Receive Equipments
								</a>
								{/* <a
									style={{
										cursor: 'pointer',
									}}
									onClick={(e) => this.showReAssignEquipments(e)}
								>
									Re-assign Equipments
								</a> */}
							</div>
						) : (
							''
						)}
					</div>
				</div>
			</Modal>
		);
	}
}
export default withRouter(EqTableFullScreen);
